import React, { useEffect } from 'react';
import './LandingPage.css';
import logo from './assets/studyhub-logo2.png';

const featureCards = [
  {
    title: 'Organized Materials',
    copy: 'From seniors to juniors knowledge passed forward',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z" />
      </svg>
    ),
  },
  {
    title: 'Learning Roadmap',
    copy: 'Your journey, structured step by step',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z" />
      </svg>
    ),
  },
  {
    title: 'Predict Papers',
    copy: 'Data based prediction for last minute preparation',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
      </svg>
    ),
  },
];



function LandingPage({ isActive = true, onNavigate }) {
  useEffect(() => {
    if (isActive) {
      document.body.classList.add('landing-route');
    } else {
      document.body.classList.remove('landing-route');
    }

    return () => {
      document.body.classList.remove('landing-route');
    };
  }, [isActive]);

  return (
    <div className="landing-page">
      <div className="landing-bg-orb landing-bg-orb-one" />
      <div className="landing-bg-orb landing-bg-orb-two" />

      <header className="landing-topbar">
        <a className="landing-brand" href="/landing">
          <img src={logo} alt="StudyHub logo" />
          <span>StudyHub</span>
        </a>

        <nav className="landing-nav" aria-label="Landing navigation">
          <a href="/app" onClick={onNavigate} className="landing-primary-action" style={{ minHeight: '44px', fontWeight: '600' }}>
            Open App
          </a>
        </nav>
      </header>

      <main className="landing-main">
        <section className="landing-hero">
          <div className="landing-badge">
            <img src={logo} alt="" aria-hidden="true" />
            <span>Your AI Study Buddy</span>
          </div>

          <h1 className="landing-title">
            <span className="landing-title-primary">Study Smarter,</span>{' '}
            <span className="landing-title-accent">Not Harder</span>
          </h1>

          <p className="landing-subtitle">
            Everything you need to prepare for exams in one place.
          </p>
          
          <div className="landing-actions" style={{ marginTop: '32px' }}>
            <a href="/app" onClick={onNavigate} className="landing-primary-action" style={{ fontSize: '1.2rem', padding: '0 32px' }}>
              Open App →
            </a>
          </div>
        </section>


        <section className="landing-section" id="features">
          <div className="landing-feature-grid">
            {featureCards.map((item) => (
              <a href="/app" onClick={onNavigate} key={item.title} className="landing-feature-card" style={{ textDecoration: 'none' }}>
                <div className="landing-feature-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.copy}</p>
              </a>
            ))}
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <div className="landing-footer-brand">
          <img src={logo} alt="" aria-hidden="true" />
          <span>StudyHub</span>
        </div>
        <p>© 2026 StudyHub. Built for students, by students.</p>
      </footer>
    </div>
  );
}

export default LandingPage;
